import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../../translations';
import { VisitTemplates } from '../VisitTemplates';
import { VisitTemplateInsert } from '../VisitTemplates.types';
import { VisitTemplatesSendTemplateButton } from '../VisitTemplatesSendTemplateButton';
import { VisitTemplatesUseTemplateModalConfirmButton } from '../VisitTemplatesUseTemplateModalConfirmButton';

import { StyledVisitTemplatesModalContent } from './VisitTemplatesModalContent.styled';

type VisitTemplatesModalProps = {
   readonly onClose: VoidFunction;
   readonly onInsert: VisitTemplateInsert;
   readonly initialEditItem: Omit<VisitTemplate, 'id'> | (() => Omit<VisitTemplate, 'id'>) | undefined;
};

export const VisitTemplatesModal = (props: VisitTemplatesModalProps): JSX.Element => {
   return (
      <FormsTemplates.Modal
         testId={'visitTemplates'}
         title={visitTemplatesTranslationKeys.visitTemplates}
         disableScroll
      >
         <StyledVisitTemplatesModalContent>
            <VisitTemplates
               initialEditItem={props.initialEditItem}
               onInsert={props.onInsert}
               editSlot={({ handleSubmit, ready, onTemplateSaveSuccess, formState, templateEmpty }) => (
                  <>
                     <VisitTemplatesSendTemplateButton
                        handleSubmit={handleSubmit}
                        onSuccess={onTemplateSaveSuccess}
                        disabled={ready}
                        shouldConfirmEmptyTemplate={templateEmpty}
                     />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
               readOnlySlot={
                  <VisitTemplatesUseTemplateModalConfirmButton
                     onClick={(template) => {
                        props.onInsert(template.id, ['interview', 'physicalExamination', 'recommendations']);
                        props.onClose();
                     }}
                  />
               }
            >
               {<FormsTemplates.ExitModalButtons onCancel={props.onClose} />}
            </VisitTemplates>
         </StyledVisitTemplatesModalContent>
      </FormsTemplates.Modal>
   );
};
